import { Button, ButtonGroup, Image, Stack, Box } from "@chakra-ui/react"
import { UI } from "components"
import { Pressable } from "components/ui"

export default function Ads({ image_url, url, imageStyle, clickable = true, bottom_message = null, bottom_message_url = null }) {
    const handleClick = () => {
        if (clickable && url) window.open(url)
    }

    const imageElement = imageStyle?.responsiveRatio ? (
        <Box
            maxW="404px"
            w="100%"
            borderRadius={6}
            overflow="hidden"
            position="relative"
            _before={{
                content: '""',
                display: "block",
                paddingBottom: `${(505 / 404) * 100}%`,
            }}
        >
            <Image
                src={image_url}
                alt=""
                objectFit="cover"
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                borderRadius={6}
            />
        </Box>
    ) : (
        <Image src={image_url} w="100%" borderRadius={6} objectFit="cover" {...imageStyle} />
    )

    return (
        <UI.Box>
            <Stack>
                {clickable ? (
                    <Pressable onClick={handleClick}>{imageElement}</Pressable>
                ) : (bottom_message_url ? (
                    <Pressable onClick={() => window.open(bottom_message_url)}>{imageElement}</Pressable>
                ) : (
                    imageElement
                ))}

                {bottom_message && (
                    <ButtonGroup minW={0} variant="subtle" size="sm">
                        <Button
                            w="100%"
                            h="auto"
                            p={3}
                            display="block"
                            wordBreak="break-word"
                            whiteSpace="normal"
                            textAlign="justify"
                            onClick={(bottom_message_url) ? () => window.open(bottom_message_url) : ''}
                        >
                            {bottom_message}
                        </Button>
                    </ButtonGroup>
                )}

                {clickable && (
                    <ButtonGroup variant="subtle" size="sm">
                        <Button onClick={handleClick}>
                            <UI.Icon name="info" /> Saiba mais
                        </Button>
                    </ButtonGroup>
                )}
            </Stack>
        </UI.Box>
    )
}